import { render, staticRenderFns } from "./water_station.vue?vue&type=template&id=4d49d54d&"
import script from "./water_station.vue?vue&type=script&lang=js&"
export * from "./water_station.vue?vue&type=script&lang=js&"
import style0 from "./water_station.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports